import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { ConversationExportCategorySelectionChange } from 'src/core/actions/conversation/conversation-export-preference.actions';
import { ConversationExportCategorySelectionModel } from 'src/core/models/conversation/conversation-export-category-selection.model';
import { ConversationExportPreferenceStateModel } from 'src/core/models/conversation/conversation-export-preference.state-model';
import { UserStateSettingsService } from 'src/core/services/state/user-state-settings.service';
import { GenericState } from 'src/core/states/generic/generic.state';
const name = 'ConversationExportPreferenceState';
const maxCategorySelectionCount = 100;
@State<ConversationExportPreferenceStateModel>({
  name: name,
  defaults: {
    categorySelections: {},
  },
})
@Injectable()
export class ConversationExportPreferenceState extends GenericState<ConversationExportPreferenceState> {
  constructor(userSettingsService: UserStateSettingsService) {
    super(userSettingsService);
    this.name = name;

    this.userSettingsService.register(this.name, this);
  }

  @Selector()
  static getCategorySelection(state: ConversationExportPreferenceStateModel) {
    return (fingerprint: string): ConversationExportCategorySelectionModel | undefined => {
      const selections = state?.categorySelections ?? {};

      return fingerprint ? selections[fingerprint] : undefined;
    };
  }

  @Action(ConversationExportCategorySelectionChange)
  changeCategorySelection(
    ctx: StateContext<ConversationExportPreferenceStateModel>,
    action: ConversationExportCategorySelectionChange,
  ) {
    const currentSelections = ctx.getState()?.categorySelections ?? {};
    const categorySelections: { [fingerprint: string]: ConversationExportCategorySelectionModel } =
      { ...currentSelections };

    categorySelections[action.fingerprint] = {
      allSelected: action.allSelected,
      queryIds: [...(action.queryIds ?? [])],
      updatedAt: Date.now(),
    };

    const fingerprints = Object.keys(categorySelections);
    if (fingerprints.length > maxCategorySelectionCount) {
      fingerprints
        .sort((a, b) => categorySelections[a].updatedAt - categorySelections[b].updatedAt)
        .slice(0, fingerprints.length - maxCategorySelectionCount)
        .forEach(fingerprint => delete categorySelections[fingerprint]);
    }

    const value: ConversationExportPreferenceStateModel = { categorySelections };

    this.userSettingsService.patchState(ctx, value, name, 0);
  }
}
